export const hi = {
  "app.title": "survivrr.io",
  "menu.online": "ऑनलाइन",
  "menu.offline": "ऑफ़लाइन",
  "menu.play": "खेलें",
  "menu.name": "नाम",
  "menu.ballColor": "गेंद का रंग",
  "menu.nameColor": "नाम का रंग",
  "menu.moreInfo": "अधिक जानकारी",
  "menu.moreInfoTitle": "अधिक जानकारी",
  "menu.moreInfoSubtitle": "कानूनी पेज, कुकी विवरण और संपर्क जानकारी।",
  "menu.back": "वापस",
  "menu.privacySettings": "गोपनीयता सेटिंग्स",
  "menu.cookiePolicy": "कुकी नीति",
  "menu.privacyPolicy": "गोपनीयता नीति",
  "menu.termsOfService": "सेवा की शर्तें",
  "menu.emailButton": "मुझे ई-मेल करें",
  "menu.websiteButton": "मेरी वेबसाइट देखें",
  "menu.contactEmailLabel": "संपर्क ई-मेल:",
  "menu.emailLabel": "ई-मेल:",
  "menu.websiteLabel": "मेरी वेबसाइट देखें:",
  "menu.nameRequired": "पहले नाम दर्ज करें।",
  "moreInfo.privacySettings.intro1": "जब उपलब्ध हो, तो आप हमारे विज्ञापन प्रदाता द्वारा दिखाए गए सहमति संदेश के माध्यम से इस साइट पर अपनी गोपनीयता पसंदें प्रबंधित कर सकते हैं।",
  "moreInfo.privacySettings.intro2": "आप किसी भी समय अपने ब्राउज़र सेटिंग्स में कुकीज़ और स्थानीय स्टोरेज को भी नियंत्रित कर सकते हैं।",
  "moreInfo.privacySettings.adsHeading": "विज्ञापन नियंत्रण",
  "moreInfo.privacySettings.adsParagraph": "कुछ विज्ञापन Google या अन्य साझेदारों द्वारा दिए जा सकते हैं। व्यक्तिगत विज्ञापन विकल्प सीधे Google विज्ञापन सेटिंग्स में भी प्रबंधित किए जा सकते हैं।",
  "moreInfo.privacySettings.adsBullet1": "Google विज्ञापन नियंत्रण myadcenter.google.com पर खोलें।",
  "moreInfo.privacySettings.adsBullet2": "यदि आप अपनी सहमति पसंदें रीसेट करना चाहते हैं, तो कुकीज़ या साइट डेटा साफ़ करें।",
  "moreInfo.privacySettings.adsBullet3": "कुकीज़ को ब्लॉक या सीमित करने के लिए अपने ब्राउज़र की गोपनीयता सेटिंग्स का उपयोग करें।",
  "moreInfo.privacySettings.localHeading": "स्थानीय सेटिंग्स",
  "moreInfo.privacySettings.localParagraph": "यह गेम खिलाड़ी का नाम, रंग, ध्वनि पसंद और भाषा जैसी बुनियादी स्थानीय पसंदें सहेजता है ताकि साइट उन्हें आपके डिवाइस पर याद रख सके।",
  "moreInfo.cookiePolicy.intro1": "यह साइट गेम चलाने, आपकी सेटिंग्स याद रखने और विज्ञापन का समर्थन करने के लिए कुकीज़ और समान स्टोरेज तकनीकों का उपयोग करती है।",
  "moreInfo.cookiePolicy.intro2": "आपकी सहमति पसंदों और साइट पर सक्षम सेवाओं के आधार पर कुकीज़ मापन, धोखाधड़ी रोकथाम और विज्ञापन वैयक्तिकरण के लिए भी उपयोग की जा सकती हैं।",
  "moreInfo.cookiePolicy.typesHeading": "कुकीज़ और स्टोरेज के प्रकार जिनका हम उपयोग कर सकते हैं",
  "moreInfo.cookiePolicy.typeBullet1": "साइट को चालू रखने के लिए आवश्यक स्टोरेज।",
  "moreInfo.cookiePolicy.typeBullet2": "आपका नाम, रंग, भाषा और ध्वनि सेटिंग याद रखने के लिए पसंद स्टोरेज।",
  "moreInfo.cookiePolicy.typeBullet3": "जब विज्ञापन सक्षम हों, तब Google जैसे विज्ञापन साझेदारों द्वारा उपयोग की जाने वाली विज्ञापन या मापन कुकीज़।",
  "moreInfo.cookiePolicy.manageHeading": "कुकीज़ कैसे प्रबंधित करें",
  "moreInfo.cookiePolicy.manageParagraph": "जब उपलब्ध हो, तो आप साइट के सहमति संदेश के माध्यम से या अपने ब्राउज़र सेटिंग्स से कुकीज़ प्रबंधित कर सकते हैं। कुछ कुकीज़ बंद करने से साइट सुविधाएँ या विज्ञापन वितरण प्रभावित हो सकता है।",
  "moreInfo.privacyPolicy.intro1": "यह साइट Michał Kierzkowski द्वारा संचालित एक ब्राउज़र गेम है। हम यथासंभव कम व्यक्तिगत जानकारी एकत्र करने का प्रयास करते हैं।",
  "moreInfo.privacyPolicy.intro2": "खेलने के लिए खाते की आवश्यकता नहीं है। गेम आपके डिवाइस पर बुनियादी स्थानीय पसंदें सहेज सकता है और ऑनलाइन मैचों को चलाने के लिए आवश्यक गेमप्ले डेटा प्रोसेस कर सकता है।",
  "moreInfo.privacyPolicy.infoHeading": "जानकारी जिसे हम प्रोसेस कर सकते हैं",
  "moreInfo.privacyPolicy.infoBullet1": "आपका चुना हुआ खिलाड़ी नाम और कॉस्मेटिक सेटिंग्स।",
  "moreInfo.privacyPolicy.infoBullet2": "मल्टीप्लेयर सुविधाएँ चलाने के लिए आवश्यक बुनियादी सत्र डेटा।",
  "moreInfo.privacyPolicy.infoBullet3": "यदि ऐसी सेवाएँ सक्षम हों, तो विश्लेषण या विज्ञापन साझेदारों द्वारा एकत्र डिवाइस, ब्राउज़र या विज्ञापन डेटा।",
  "moreInfo.privacyPolicy.useHeading": "हम जानकारी का उपयोग कैसे करते हैं",
  "moreInfo.privacyPolicy.useBullet1": "गेम और ऑनलाइन कमरों को चलाने के लिए।",
  "moreInfo.privacyPolicy.useBullet2": "आपके डिवाइस पर आपकी सेटिंग्स याद रखने के लिए।",
  "moreInfo.privacyPolicy.useBullet3": "प्रदर्शन, सुरक्षा और स्थिरता सुधारने के लिए।",
  "moreInfo.privacyPolicy.useBullet4": "जब विज्ञापन सक्षम हों, तो विज्ञापन दिखाने के लिए।",
  "moreInfo.privacyPolicy.contactHeading": "संपर्क",
  "moreInfo.privacyPolicy.contactParagraph1": "यदि आपके पास गोपनीयता से जुड़े प्रश्न हैं, तो संपर्क करें: mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "वेबसाइट: michalkierzkowski.com",
  "moreInfo.terms.intro1": "इस साइट का उपयोग करके आप गेम को कानूनी और निष्पक्ष तरीके से उपयोग करने पर सहमत होते हैं।",
  "moreInfo.terms.intro2": "गेम जैसा है वैसा ही प्रदान किया जाता है और इसे किसी भी समय बदला, बाधित या हटाया जा सकता है।",
  "moreInfo.terms.rulesHeading": "नियम",
  "moreInfo.terms.ruleBullet1": "बग, चीट, ऑटोमेशन या एक्सप्लॉइट का दुरुपयोग न करें।",
  "moreInfo.terms.ruleBullet2": "सेवा या अन्य खिलाड़ियों को नुकसान पहुँचाने की कोशिश न करें।",
  "moreInfo.terms.ruleBullet3": "आपत्तिजनक, अवैध या भ्रामक नाम या सामग्री का उपयोग न करें।",
  "moreInfo.terms.limitationHeading": "सीमा",
  "moreInfo.terms.limitationParagraph": "कानून द्वारा अनुमत अधिकतम सीमा तक, साइट के उपयोग से होने वाली हानि, रुकावट या नुकसान के लिए हम जिम्मेदार नहीं हैं।",
  "moreInfo.terms.changesHeading": "बदलाव",
  "moreInfo.terms.changesParagraph": "इन शर्तों को भविष्य में अपडेट किया जा सकता है। अपडेट के बाद साइट का उपयोग जारी रखने का मतलब है कि आप अपडेट की गई शर्तों को स्वीकार करते हैं।",
  "status.offline": "ऑफ़लाइन मैच शुरू हो रहा है...",
  "status.connecting": "सर्वर से कनेक्ट हो रहा है...",
  "queue.title": "कमरे की प्रतीक्षा",
  "queue.menu": "मुख्य मेनू पर लौटें",
  "game.pressToMove": "चलने के लिए कहीं भी दबाएँ",
  "game.touchToMove": "चलने के लिए कहीं भी छुएँ",
  "game.leaderboard": "लीडरबोर्ड",
  "game.hp": "HP",
  "game.level": "स्तर",
  "game.xp": "XP",
  "game.respawning": "फिर से जन्म हो रहा है...",
  "gameEnd.title": "गेम समाप्त",
  "gameEnd.winTitle": "आप जीत गए",
  "gameEnd.subtitle": "मैच समाप्त हो गया है। अगला राउंड शुरू करने के लिए फिर से जन्म लें या मेनू पर लौटें।",
  "pause.title": "गेम मेनू",
  "pause.resume": "जारी रखें",
  "pause.menu": "मुख्य मेनू पर लौटें",
  "upgrade.title": "अपग्रेड चुनें",
  "upgrade.generic.title": "अपग्रेड",
  "upgrade.generic.description": "अपनी build सुधारें।",
  "upgrade.newWeaponPrefix": "नया हथियार:",
  "upgrade.stat.maxHp.title": "अधिकतम HP",
  "upgrade.stat.maxHp.description": "अधिकतम HP बढ़ाएँ।",
  "upgrade.stat.speed.title": "चलने की गति",
  "upgrade.stat.speed.description": "चलने की गति बढ़ाएँ।",
  "upgrade.stat.generic.title": "स्टेट अपग्रेड",
  "upgrade.stat.generic.description": "अपने स्टेट्स सुधारें।",
  "upgrade.weapon.projectileShot.title": "प्रोजेक्टाइल शॉट",
  "upgrade.weapon.projectileShot.description": "अपनी build में प्रोजेक्टाइल शॉट जोड़ें।",
  "upgrade.weapon.orbitingBalls.title": "घूमती गेंदें",
  "upgrade.weapon.orbitingBalls.description": "अपनी build में घूमती गेंदें जोड़ें।",
  "upgrade.weapon.damageZone.title": "डैमेज ज़ोन",
  "upgrade.weapon.damageZone.description": "अपने पात्र के चारों ओर डैमेज ज़ोन जोड़ें।",
  "upgrade.weapon.generic.title": "हथियार",
  "upgrade.weapon.generic.description": "इस हथियार को अपनी build में जोड़ें।",
  "upgrade.weaponUpgrade.frequency.title": "आवृत्ति",
  "upgrade.weaponUpgrade.frequency.description": "अधिक बार हमला करें।",
  "upgrade.weaponUpgrade.range.title": "रेंज",
  "upgrade.weaponUpgrade.range.description": "हथियार की रेंज बढ़ाएँ।",
  "upgrade.weaponUpgrade.projectileCount.title": "प्रोजेक्टाइल संख्या",
  "upgrade.weaponUpgrade.projectileCount.description": "अधिक प्रोजेक्टाइल बनाएँ।",
  "upgrade.weaponUpgrade.projectileSpeed.title": "प्रोजेक्टाइल गति",
  "upgrade.weaponUpgrade.projectileSpeed.description": "प्रोजेक्टाइल को तेज़ बनाएं।",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "ऑर्बिटल गति",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "घूमती गेंदों को तेज़ घुमाएँ।",
  "upgrade.weaponUpgrade.damage.title": "डैमेज",
  "upgrade.weaponUpgrade.damage.description": "अधिक डैमेज दें।",
  "upgrade.weaponUpgrade.generic.title": "हथियार अपग्रेड",
  "upgrade.weaponUpgrade.generic.description": "इस हथियार को सुधारें।",
  "defeat.title": "हार",
  "defeat.subtitle": "फिर से जन्म लें या मेनू पर लौटें",
  "defeat.respawn": "Respawn",
  "defeat.menu": "मुख्य मेनू",
  "error.generic": "कुछ गलत हो गया।",
} as const;
